class CartFunctions {
   
  
  constructor() {}
   
  
  async findItemInCart(id){
    let findAddedItem = await this.getCart();
    let thisID = id;
    let itemFound = findAddedItem.items.filter(itm => itm.variant_id === thisID);        
    if(!itemFound.length) {
      return false;
    } else {  
      return [true,itemFound];
    }    
  }
  
  
  async getCart() {
    const result = await fetch("/cart.json");
    if (result.status === 200) {
      return result.json();
    }
    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
  }
  
  
  async setCartAttributes(attributes = {}) {
    const result = await fetch("/cart/update.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            attributes: attributes 
        })
    });    
    return result.json();
  }
    
  
  async addItem(id, qty) {  
    const result = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: id,
        quantity: qty
      })
    })
    
    return result;
  }
  
  
  async addItems(ids) {   
    const data = {items: ids};
    const result = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },        
      body: JSON.stringify(data)        
    });
    return result;
  }

   
  async addItemWithProperties(id, qty, properties = {}) {

    const result = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: id,
        quantity: qty,
        properties: properties
      })
    })

  }
  
  
  async updateItemByID(id, newQty) {
    const result = await fetch(`/cart/change.json?id=${id}&quantity=${newQty}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    });

    return result.json();
  }
  
   
  async updateItemByLine(line_index, newQty, newProperties = {}) {

    const result = await fetch(`/cart/change.json?line=${line_index}&quantity=${newQty}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        "line": line_index,
        "quantity": line_index,
        "properties": newProperties
      })
    });

    return result.json();
  }
  
  
  async removeItemByID(id) {    
    const result = await fetch("/cart/change.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        'id': `${id}`,
        'quantity': 0
      })
    });

    return result.json();
  }

  
  async removeItemsByIDs(...productIDS) {
    let data = { 'updates': {} };
    var productID;
    for (productID in productIDS) {
      data['updates'][parseInt(productIDS[productID])] = 0;
    }

    let info = fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => { return data })
    .catch((error) => { console.error('Error:', error) });    
  }

  
  async removeItemByLine(line_index) {
    const result = await fetch(`/cart/change.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        "line": line_index,
        "quantity": 0
      })
    });

    return result.json();
  }
  
  
  async setNote(note) {

    const result = await fetch("/cart/update.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        note: note
      })
    });

    return result.json();
  }

  
  async clearCart() {
    const result = await fetch({
      method: "POST",
      headers: {
        "Accept": "application/json"
      }
    });

    return result.json();
  }

  
  async countCartItems() {            
    const fetchCart = await this.getCart();         
    let itemsInCartCurrently = fetchCart.item_count;
    
    return itemsInCartCurrently;

  }
  
  
}


class LocalStorageFunctions {

  
  constructor () {}
 
  
  checkStorage(keyName) {
    if (localStorage.getItem(keyName) !== null) {
      return true;
    } else {
      return false;
    }
  }
 
  
  getStorage(keyName) {
    let retrievedIDObject = localStorage.getItem(keyName);   
    let parsedObject = JSON.parse(retrievedIDObject);    
    return parsedObject;  
  }

  
  setStorage(ids_object, keyName) {   
    localStorage.setItem(keyName, JSON.stringify(ids_object));
  }
  
  
  removeFromStorage(keyName) {
  	localStorage.removeItem(keyName);
  }
  
  
}


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}


document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});


const trapFocusHandlers = {};


function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}


// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}


function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}


function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}


function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}


function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-input', QuantityInput);


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}


/* Shopify Common JS */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}


Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};


Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};


Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};


Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};


Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};


Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};


class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define('menu-drawer', MenuDrawer);


class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}
customElements.define('header-drawer', HeaderDrawer);


class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);


class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);


class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}
customElements.define('deferred-media', DeferredMedia);


class SliderComponent extends HTMLElement {
  
  
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.rootMargin = "0px -45% 0px -45%";
        
    if(window.matchMedia('(max-width: 49em)').matches) {
      this.setupObserver(this.rootMargin);
    }  
    
    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }
 
  
  setupObserver = (rootMargin) => {

    const elements = [...this.querySelectorAll('.sm_product_slider li')];
     
    function observerCallback(entries, observer) { 
      entries.forEach((entry,index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            elements.forEach(el => { el.classList.remove('active') })      
            entry.target.classList.add('active');
            [...document.querySelectorAll('.dots .filled-circle')].forEach((dot) => { dot.style.background = '#d7d7d8'; })
            document.querySelector(`.dot[data-position="${entry.target.dataset.position}"] .filled-circle`).style.background = '#adafb2'; 
          }, 50)          
        }      
      })  
    }  

    const options = { rootMargin };
    const observer = new IntersectionObserver(observerCallback, options);
    elements.forEach(el => observer.observe(el));
    
  }
	
   
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }


  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }


  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }


  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }


  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }


}
customElements.define('slider-component', SliderComponent);


class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}
customElements.define('slideshow-component', SlideshowComponent);


class VariantSelects extends HTMLElement {
  
  
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  
  updateMasterId() {   
    this.currentVariant = this.getVariantData().filter(variant => variant.options[1] === this.querySelector('#sizesSelector').value);
  }

  
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant[0].featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant[0].id}`);
  }

  
  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant[0].id}`);
  }

  
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant[0].id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  
  updatePickupAvailability() {

    const pickUpAvailability = document.querySelector('pickup-availability');
    //console.log('1', pickUpAvailability)

    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant[0].available) {
      //console.log('2-a')
      pickUpAvailability.fetchAvailability(this.currentVariant[0].id);
    } else {
      //console.log('2-b')
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  
  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant[0].id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant[0].available, window.variantStrings.soldOut);
      });
  }
  

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    const availableNow =  document.querySelector('.isAvailableNow');    
    
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      availableNow.classList.add('lg-0');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      availableNow.classList.remove('lg-0');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }
  

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);    
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  
  
}
customElements.define('variant-selects', VariantSelects);


class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}
customElements.define('variant-radios', VariantRadios);


class GdprBeforeForm extends HTMLElement {
   
  
  constructor() {
    super();
        
    this.boxWrap = this.querySelector('.emailFormBox');
    this.input = this.querySelector('input[type="checkbox"]');
    this.warning = this.querySelector('.email-form-warning');
    this.checkoutBtn = document.querySelector('#Subscribe');    
    this.preventer = document.querySelector('.emailSubmitPreventer');
   
    this.debouncedOnChange = debounce((event) => {
      this.checkGDPR(event);
    }, 100);
    this.addEventListener('change', this.debouncedOnChange.bind(this));
    window.addEventListener('load', this.debouncedOnChange.bind(this));
    this.preventer.addEventListener('click', this.debouncedOnChange.bind(this));   
  }
  
  
  checkGDPR(event) {      
    if(this.input.checked){
      this.checkoutBtn.classList.remove('not-allowed');
      this.checkoutBtn.classList.add('pointer');
      this.checkoutBtn.disabled = false;            
      this.warning.classList.add('none'); 
      this.preventer.classList.add('none');
    } else {               
      if(event.type === 'click') {
        this.preventer.classList.add('not-allowed');
        this.preventer.classList.remove('pointer');
        this.warning.classList.remove('none'); 
      }
      
      this.checkoutBtn.disabled = true; 
      this.preventer.classList.remove('none');
      this.preventer.classList.add('block');
    }   
  } 
  
}
customElements.define('newsletter-submit', GdprBeforeForm);


class Favorites extends HTMLElement {
  
  
  constructor() {
    super();
    this.favList  = this.querySelector('.fav-list');
    this.LocalStorageKey = 'fav-list';
    this.itemTemplate = this.querySelector('#product-card-fav-template'); 
    this.priceNormalTemplate = this.querySelector('#price-normal-fav-template'); 
    this.priceSaleTemplate = this.querySelector('#price-sale-fav-template');
    this.noFavorites = document.querySelector('.favorites_no_results');
    this.localStorageFunctions = new LocalStorageFunctions();
    this.populateComponent();
  }
  
  
  populateComponent() {
    let retrievedList = this.localStorageFunctions.getStorage(this.LocalStorageKey); 
    //console.log('retrievedList', retrievedList)
    
    if(retrievedList && retrievedList.length > 0) {      
      this.fetchItems(retrievedList);
      this.noFavorites.classList.add('none');
      this.classList.remove('none');
    } else {
      this.classList.add('none');
      this.noFavorites.classList.remove('none');
    }
  }

  
  fetchItems(items) {    
    items.forEach((item)=> {    
      fetch(`/products/${item.handle}.js`)       
      .then(response => response.text())
      .then(text => {
        let itemProps = JSON.parse(text);        
        this.createFavItem(itemProps);
      }).catch(e => { console.error(e) })      
    });    
  }
  
  
  createFavItem(itemProps) {

    let clone = this.itemTemplate.content.cloneNode(true);
    
    clone.querySelectorAll('a').forEach((link)=>{
      link.href = `${itemProps.url}` 
      if (link.classList.contains('no-decoration')){
        link.style.backgroundColor = '#f9f8f5';
      }
    });
      
    clone.querySelector('.product-card-title a').textContent = `${itemProps.title}`;      
    clone.querySelector('.svg').dataset.prodid = `${itemProps.id}`;
    clone.querySelector('.svg').dataset.prodhandle = `${itemProps.handle}`;
            
    if(itemProps.hasOwnProperty('media')){
        
      let itemMedia = itemProps.media;
      let imageExistsCnt = 0;
      let imagesIndexArray = [];
        
      itemMedia.forEach((media, index) => {
        if (media.media_type != 'video' && imageExistsCnt < 2){
          imagesIndexArray.push(index);
          imageExistsCnt+=1;
        }
      })

      if (imageExistsCnt == 1) {
        let img = document.createElement('IMG');
        img.classList.add('absolute', 'top-0', 'left-0', 'w-p100', 'h-p100', 'object-cover', 'object-center', 'transition-linear');
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'auto');
        clone.querySelector('.product-card-media a').innerHTML = '';
        clone.querySelector('.product-card-media a').append(img);  

        itemProps.media[imagesIndexArray[0]].alt !== null ? clone.querySelector('img').alt = `${itemProps.media[imagesIndexArray[0]].alt}` : clone.querySelector('img').alt = `${itemProps.title}`; 
        clone.querySelector('img').width = `${itemProps.media[imagesIndexArray[0]].width}`;
        clone.querySelector('img').height = `${itemProps.media[imagesIndexArray[0]].height}`;
        clone.querySelector('img').src = `${itemProps.media[imagesIndexArray[0]].src}`;
        clone.querySelector('img').classList.add('mix-mode-darken');
      }
           
      if (imageExistsCnt == 2) {       
        let img = document.createElement('IMG');
        img.classList.add('featured', 'absolute', 'top-0', 'left-0', 'w-p100', 'h-p100', 'object-cover', 'object-center', 'transition-linear');
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'auto');
        clone.querySelector('.product-card-media a').innerHTML = '';
        clone.querySelector('.product-card-media a').append(img);  

        itemProps.media[imagesIndexArray[0]].alt !== null ? clone.querySelector('img').alt = `${itemProps.media[imagesIndexArray[0]].alt}` : clone.querySelector('img').alt = `${itemProps.title}`; 
        clone.querySelector('.featured').width = `${itemProps.media[imagesIndexArray[0]].width}`;
        clone.querySelector('.featured').height = `${itemProps.media[imagesIndexArray[0]].height}`;
        clone.querySelector('.featured').src = `${itemProps.media[imagesIndexArray[0]].src}`;
        clone.querySelector('.featured').classList.add('mix-mode-darken');


        let img2 = document.createElement('IMG');
        img2.classList.add('secondary', 'absolute', 'top-0', 'left-0', 'w-p100', 'h-p100', 'object-cover', 'object-center', 'transition-linear');
        img2.setAttribute('loading', 'lazy');
        img2.setAttribute('decoding', 'auto');

        clone.querySelector('.product-card-media a').append(img2);  

        itemProps.media[imagesIndexArray[1]].alt !== null ? clone.querySelector('img').alt = `${itemProps.media[imagesIndexArray[1]].alt}` : clone.querySelector('img').alt = `${itemProps.title}`; 
        clone.querySelector('.secondary').width = `${itemProps.media[imagesIndexArray[1]].width}`;
        clone.querySelector('.secondary').height = `${itemProps.media[imagesIndexArray[1]].height}`;
        clone.querySelector('.secondary').src = `${itemProps.media[imagesIndexArray[1]].src}`;
        clone.querySelector('.secondary').classList.add('mix-mode-darken');
      }
 
    } else {
  
      let svgFallback = `
		<svg class="placeholder-svg w-p100 h-p100" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5">
          <path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"></path>
          <path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z"></path>
          <path d="M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z"></path>
		</svg>
      `;
      
      if(clone.querySelector('.featured')!= null){clone.querySelector('.featured').remove() }      
      if(clone.querySelector('.secondary')!= null){clone.querySelector('.secondary').remove() }	
      
      const parser = new DOMParser();
      const parsedSvg = parser.parseFromString(svgFallback, "image/svg+xml");
      let selectedParsedSvg = parsedSvg.querySelector('svg');        
      clone.querySelector('a').append(selectedParsedSvg);
    }
            
    if(itemProps.compare_at_price != null){
      let price_cat = this.priceSaleTemplate.content.cloneNode(true);
      price_cat.querySelector('.price-compare s').textContent = `${new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(itemProps.compare_at_price / 100)}`; 
      price_cat.querySelector('.price-item-sale').textContent = `${new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(itemProps.price / 100)}`;
      clone.querySelector('.product-card-price').innerHTML = ''
      clone.querySelector('.product-card-price').append(price_cat);
    } else {
      let price_nrm = this.priceNormalTemplate.content.cloneNode(true);      
      price_nrm.querySelector('.price-regular .price-item-regular').textContent = `${new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(itemProps.price / 100)}`;
      clone.querySelector('.product-card-price').innerHTML = '';
      clone.querySelector('.product-card-price').append(price_nrm);
    }
    this.favList.append(clone); 
          
  } 
 
  
}
customElements.define('favorites-component', Favorites);


class toggleFavoriteItem extends HTMLElement {
   
  
  constructor() {      
    super();
    this.localStorageFunctions = new LocalStorageFunctions();
    this.favBtn = this.querySelector('button');

    this.favProdId = this.favBtn.dataset.prodid;
    this.favProdHandle = this.favBtn.dataset.prodhandle;
    this.favAriaPressed = this.favBtn.getAttribute('aria-pressed');
    //this.favBtnFilled = this.favBtn.dataset.filled;

    this.favIDs = { "id": this.favProdId, "handle": this.favProdHandle };    
    this.LocalStorageKey = 'fav-list';

    let check = this.checkForKey();
    this.favBtnEventListeners();  
  }
  
  
  checkForKey() {   
      
      let favListObject = this.localStorageFunctions.getStorage(this.LocalStorageKey);   
      if (favListObject != null) {
       
        let isAlreadyInFavorites = false;
		  
        if(favListObject.length != 0){

          favListObject.forEach((entry, index) => { 
            if(this.favProdId == entry.id ){
              isAlreadyInFavorites = true;
            }    
          })

          if(isAlreadyInFavorites == true){
            this.renderFilledHeart();
            this.favBtn.dataset.filled="true";
          } else {
            this.renderEmptyHeart();
          }
        } else {
          this.renderEmptyHeart();
        } 
      } else {
        this.renderEmptyHeart();
      }  

    }
  
  
  toggleFavoritesIndicator(state) {
    state == 'inStorage' ? this.renderFilledHeart() : this.renderEmptyHeart();
  }
  
  
  renderFilledHeart(){
    let filledHeart = `
      <svg class="block mrg-auto filled-heart" width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.25975 14.8572C8.25975 14.8572 7.62958 14.7567 7.54429 14.8574C7.7482 15.0477 8.05584 15.0475 8.25975 14.8572Z" fill="black"/>
        <path d="M7.54429 14.8574C7.62958 14.7567 8.25975 14.8572 8.25975 14.8572L8.27394 14.8439L8.31535 14.8051C8.3516 14.7711 8.40482 14.721 8.47304 14.6566C8.60948 14.5278 8.80595 14.3415 9.04666 14.1109C9.52794 13.6499 10.1868 13.0113 10.8967 12.3014C12.3047 10.8934 13.9521 9.16702 14.7905 7.99323C15.6692 6.76311 16.1227 5.20947 15.9712 3.77752C15.8169 2.32005 15.0313 0.998691 13.4835 0.348613C11.9543 -0.293659 10.5707 0.0338947 9.51851 0.665188C8.85865 1.0611 8.31503 1.58365 7.92574 2.0832C7.60065 1.60133 7.1559 1.08461 6.58594 0.685639C5.6454 0.0272671 4.3837 -0.291958 2.85852 0.348613C-0.219776 1.64149 -0.774108 5.4908 1.01335 7.99323C1.85177 9.16702 3.49919 10.8934 4.90719 12.3014C5.61706 13.0113 6.2759 13.6499 6.75719 14.1109C6.9979 14.3415 7.19437 14.5278 7.3308 14.6566C7.39902 14.721 7.45225 14.7711 7.4885 14.8051L7.5299 14.8439L7.54429 14.8574Z" fill="#e94949"/>
      </svg>
    `;
    this.favBtn.innerHTML = filledHeart;
  }
 
  
  renderEmptyHeart(){
    let emptyHeart = `
      <svg class="block mrg-auto empty-heart" width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.25975 14.8572C8.25975 14.8572 7.62958 14.7567 7.54429 14.8574C7.7482 15.0477 8.05584 15.0475 8.25975 14.8572Z" fill="white"/>
          <path d="M7.54429 14.8574C7.62958 14.7567 8.25975 14.8572 8.25975 14.8572L8.27394 14.8439L8.31535 14.8051C8.3516 14.7711 8.40482 14.721 8.47304 14.6566C8.60948 14.5278 8.80595 14.3415 9.04666 14.1109C9.52794 13.6499 10.1868 13.0113 10.8967 12.3014C12.3047 10.8934 13.9521 9.16702 14.7905 7.99323C15.6692 6.76311 16.1227 5.20947 15.9712 3.77752C15.8169 2.32005 15.0313 0.998691 13.4835 0.348613C11.9543 -0.293659 10.5707 0.0338947 9.51851 0.665188C8.85865 1.0611 8.31503 1.58365 7.92574 2.0832C7.60065 1.60133 7.1559 1.08461 6.58594 0.685639C5.6454 0.0272671 4.3837 -0.291958 2.85852 0.348613C-0.219776 1.64149 -0.774108 5.4908 1.01335 7.99323C1.85177 9.16702 3.49919 10.8934 4.90719 12.3014C5.61706 13.0113 6.2759 13.6499 6.75719 14.1109C6.9979 14.3415 7.19437 14.5278 7.3308 14.6566C7.39902 14.721 7.45225 14.7711 7.4885 14.8051L7.5299 14.8439L7.54429 14.8574Z" stroke="#000000" fill="white"/>
      </svg>
    `;
    this.favBtn.innerHTML = emptyHeart;
  }

  
  manageItem(state) {
    let lsKeyExists = this.localStorageFunctions.checkStorage(this.LocalStorageKey);
    if(state == 'add') {
      //To-Do function pou to vazei sto storage
      this.toggleFavoritesIndicator('inStorage');
    } else {
      //To-Do function pou to vgazei apo storage
      this.toggleFavoritesIndicator('notInStorage');
    }
  }
  
  
  favBtnEventListeners(){
    
    this.favBtn.addEventListener('click', () => {                               
                                   
      let lsKeyExists = this.localStorageFunctions.checkStorage(this.LocalStorageKey);

      if(lsKeyExists === false) {

        this.localStorageFunctions.setStorage([this.favIDs], this.LocalStorageKey);
        
        if(this.favBtn.dataset.filled == 'true'){
          this.favBtn.dataset.filled = "false";
          this.favBtn.setAttribute("aria-pressed", "false");
          this.renderEmptyHeart();
          if(window.location.href.indexOf("pages/favorites") > -1) {
            location.reload();
          }
        } else {
          this.favBtn.dataset.filled = "true";
          this.favBtn.setAttribute("aria-pressed", "true");
          this.renderFilledHeart();
        }

      } 

      if(lsKeyExists === true) {

        let favListObject = this.localStorageFunctions.getStorage(this.LocalStorageKey);      		
        this.favBtn.innerHTML = '';
				
        if(this.favBtn.dataset.filled == 'true'){
          this.favBtn.dataset.filled = 'false';
          this.favBtn.setAttribute("aria-pressed", "false");
          this.renderEmptyHeart();

          let isAlreadyInFavorites = false;
          let indexToRemove;
          
          favListObject.forEach((entry, index) => {
            if(this.favProdId == entry.id){
              isAlreadyInFavorites = true;
              indexToRemove = index;
            }
          });
          
          favListObject.splice(indexToRemove, 1);
          this.localStorageFunctions.setStorage(favListObject, this.LocalStorageKey);
              	
          if(window.location.href.indexOf("pages/favorites") > -1) {
            location.reload();
          }
          
        } else {
          this.favBtn.dataset.filled = 'true';
          this.favBtn.setAttribute("aria-pressed", "true");
          this.renderFilledHeart();
          let isAlreadyInFavorites = false;
          
          favListObject.forEach((entry) => {
            if(this.favProdId == entry.id){
              isAlreadyInFavorites = true;
            }
          });
          
          if(isAlreadyInFavorites == false) {
            favListObject.push(this.favIDs);
            this.localStorageFunctions.setStorage(favListObject, this.LocalStorageKey);
          }
           
        }
                
      }

    })
  }
  
   
}
customElements.define('toggle-favorite', toggleFavoriteItem);



class quickBuyItem extends HTMLElement{
  
  	constructor() { 
      super();
      this.sizesBtns = this.querySelectorAll('.inputs_wrapper input');
      this.cartFunctions = new CartFunctions();
      this.cartNotification = new CartNotification();
      this.sizesOnClick();
    }

    disableVariant(el) {
      el.parentElement.querySelector('label').classList.remove('pointer');
      el.parentElement.querySelector('label').classList.add('color-disabled', 'disabled', 'not-allowed');
      el.disabled = true;
    }

    updateBubble(count) {
      document.querySelector('.cart-count-bubble span:first-child').textContent = `${count}`
    }


    recheck(variantId, variantInv, sizeBtn) {           
      fetch("/cart.json")
        .then((response) => response.json())
        .then((data) => {
          console.log(data)
          this.updateBubble(data.item_count);
          this.cartNotification.open();
          let check_if_in_cart = data.items.find((item) => item.variant_id == variantId);
          if(check_if_in_cart.quantity + 1 >= variantInv) { this.disableVariant(sizeBtn) }                 
      })
    }




    sizesOnClick(){
      
      this.sizesBtns.forEach((sizeBtn) => {
          sizeBtn.addEventListener('click', () => { 

          	let variantId = Number(sizeBtn.dataset.variantid);	           
            let variantInv = Number(sizeBtn.dataset.variantinv);
 
            fetch("/cart.json")
              .then((response) => response.json())
              .then((data) => {
                let check_if_in_cart = data.items.find((item) => item.variant_id == variantId);
                if(check_if_in_cart != undefined) {
                  if(check_if_in_cart.quantity >= variantInv) {
                    this.disableVariant(sizeBtn); 
                    this.cartNotification.open(false, variantInv);                  
                  } else {
                    this.cartFunctions.addItem(variantId,1);                  
                    this.updateBubble(data.item_count);
                    this.cartNotification.open();
                    if(check_if_in_cart.quantity + 1 >= variantInv) { this.disableVariant(sizeBtn) }           
                  }
                } else {
                  console.log('not in cart: adding');
                  this.cartFunctions.addItem(variantId,1); 
                  setTimeout(() => {  this.recheck(variantId, variantInv, sizeBtn);  }, 500);     
                                 
                }
              
              })

      	  })	
      })
	}
    
    
    
}
customElements.define('quick-buy-component', quickBuyItem);


